import { useState, useEffect, useMemo } from "react";
import Swal from "sweetalert2";
import api from "services/api";
import { useAuth } from "hooks/useAuth";
import { useForm } from "react-hook-form";
import moment from "moment";
import { default as ReactSelect } from "react-select";
import makeAnimated from "react-select/animated";
// import emailjs from "emailjs-com";
import { sortDESC, sortMesCompetencia, sortYear } from "utils/sort";
import {
  FormControl,
  FormLabel,
  Box,
  Flex,
  // Icon,
  Select,
  useMediaQuery,
  Alert,
  AlertIcon,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Grid,
  Input,
  Divider,
  CircularProgress,
  FormErrorMessage,
} from "@chakra-ui/react";
import { BiCommentDetail } from "react-icons/bi";
import {
  MdFileDownload,
  MdFileUpload,
  MdEdit,
  MdRecordVoiceOver,
  // MdHelpOutline,
} from "react-icons/md";
import { AiOutlineReload } from "react-icons/ai";
import { download } from "services/dowloadArquivo";
import { Link } from "react-router-dom";
import { meses } from "utils/meses";
import { useLocation } from "react-router-dom";
// import { useTour } from "@reactour/tour";

interface Document {
  id: number;
  ano_competencia: number;
  nome_arquivo_s3: string;
  tipo_documento: any;
  operadora: any;
  entidade: any;
  contrato: any;
  mes_competencia: number;
  dt_vencimento: string;
  hist_validacao_docs: any;
  status_documento: any;
  updated_at: Date;
  valor: number;
  fl_envia_pos_limite: boolean;
  hash_arquivo: string;
  created_at: any;
  fl_validando_ext_bol_not: boolean;
  fl_pendencia_ext_bol_not: boolean;
  id_arq_boleto: any;
  hash_arq_nota: any;
}

const defaultValues = {
  valor: "",
  observacao: "",
};

// const movimentacaoSteps = [
//   {
//     selector: '[id="containerSelectContract"]',
//     content:
//       "Aqui você pode selecionar um contrato para visualizar a sua movimentação.",
//   },
// ];

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const UtilizacaoPortal = () => {
  let query = useQuery();
  const animatedComponents = makeAnimated();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [contratos, setContratos] = useState<any>();
  const [mobile] = useMediaQuery("(max-width: 624px)");
  const [notebook] = useMediaQuery("(max-width: 1366px)");
  const [click, setClick] = useState<string | null>(null);
  const [observacao, setObservacao] = useState<any>(null);
  const [isSending, setIsSending] = useState<boolean>(false);

  const [selectedContract, setSelectedContract] = useState<any>(
    query.get("contrato"),
  ); // Teste 81

  const [linkExterno, setLinkExterno] = useState<any>(true);
  const [nameContrato, setNameContrato] = useState<any>(null);

  const [statusContract, setStatusContract] = useState<any>("ativo");
  const [select, setSelect] = useState<boolean>(false);
  const [vigenciaContrato, setVigenciaContrato] = useState<any>(null);
  const [vigenciaContratoAtivo, setVigenciaContratoAtivo] = useState<any>(null);
  const [years, setYears] = useState<any>(null);
  const [yearValue, setYearValue] = useState<any>(null);

  const [documentId, setdocumentId] = useState<any>(null);
  const [file, setFile] = useState<any>(null);
  const [file2, setFile2] = useState<any>(null);
  const [documents, setDocuments] = useState<Document[]>([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [pageLoadingEntidades, setPageLoadingEntidades] = useState(true);
  const { user } = useAuth();
  const { handleSubmit, reset } = useForm({
    mode: "onBlur",
  });

  // const { setIsOpen, steps, setSteps } = useTour();

  const yearMoment = moment().year(); //2021

  async function getDocuments(selectedYear: any, contractId: any) {
    setPageLoading(true);
    setVigenciaContrato(null);
    setVigenciaContratoAtivo(null);
    setSelect(true);
    let documentsArray: any[] = [];
    setDocuments([]);

    if (selectedYear) {
      try {
        await api
          .get(`/documentos?contrato=${contractId || selectedContract}`)
          .then(async (res) => {
            const reduced: any[] = [];
            res.data
              .filter((op: any) => op.tipo_documento === 10)
              .forEach((doc: any) => {
                let duplicated =
                  reduced.findIndex((item: any) => {
                    return doc.ano_competencia === item.ano_competencia;
                  }) > -1;
                if (!duplicated) {
                  reduced.push(doc);
                }
              });
            let yearsArray: any[] = [];

            reduced
              .sort(sortYear)
              .map((year: any) => yearsArray.push(year?.ano_competencia));
            setYears(yearsArray);

            const docs = res.data.filter((op: any) => op.tipo_documento === 10);

            if (docs.length > 0) {
              if (yearMoment === parseInt(selectedYear)) {
                if (
                  reduced.find(
                    (doc: any) =>
                      doc.ano_competencia === parseInt(selectedYear),
                  ) !== undefined
                ) {
                  setYearValue(yearMoment);
                  docs.map(
                    (document: any) =>
                      document.ano_competencia === yearMoment &&
                      documentsArray.push(document),
                  );
                } else {
                  if (
                    docs.find(
                      (doc: any) =>
                        doc.ano_competencia === parseInt(selectedYear),
                    ) === undefined
                  ) {
                    docs.filter(
                      (document: any) =>
                        document.ano_competencia ===
                          parseInt(docs.sort(sortYear)[0].ano_competencia) &&
                        documentsArray.push(document),
                    );
                  } else {
                    docs.map(
                      (document: any) =>
                        document.ano_competencia !== yearMoment &&
                        documentsArray.push(document),
                    );
                  }
                }
              } else {
                docs.map(
                  (document: any) =>
                    document.ano_competencia === parseInt(selectedYear) &&
                    documentsArray.push(document),
                );
              }

              setDocuments(documentsArray.sort(sortMesCompetencia));
            } else {
              const contratoVigente = contratos.find(
                (contrato: { id: any }) =>
                  contrato.id === (contractId || selectedContract),
              );

              const dataVigente = moment(
                `${contratoVigente?.ano_ini_vigenc_ext_bol_not}-${contratoVigente?.mes_ini_vigenc_ext_bol_not}`,
              );

              setVigenciaContratoAtivo(contratoVigente?.fl_ativo);

              setVigenciaContrato(dataVigente.format("MM/YYYY"));
            }
          });
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar os documentos",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    } else {
      setDocuments([]);
    }
    setPageLoading(false);
  }

  const sendFile = async (values: any) => {
    Swal.fire({
      title: "Deseja enviar?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsSending(true);
        const dataUtilizacaoAberta = new FormData();
        const dataUtilizacaoFechada = new FormData();

        dataUtilizacaoAberta.append(
          "files",
          file,
          `analitico_${observacao.mes_competencia}${
            observacao.ano_competencia
          }_${selectedContract}.${file.type.split("/")[1]}`,
        );

        dataUtilizacaoFechada.append(
          "files",
          file2,
          `sintetica_${observacao.mes_competencia}${
            observacao.ano_competencia
          }_${selectedContract}.${file2.type.split("/")[1]}`,
        );

        await api
          .post("/upload", dataUtilizacaoAberta)
          .then(async (res) => {
            const id_arq_boleto = res.data[0].id;
            const nm_arq_boleto = res.data[0].name;
            const hash_arq_boleto = res.data[0].hash + res.data[0].ext;

            await api
              .post("/upload", dataUtilizacaoFechada)
              .then(async (res) => {
                const documentData = {
                  status_documento: 12,
                  id_arq_boleto,
                  nm_arq_boleto,
                  hash_arq_boleto,
                  id_arq_nota: res.data[0].id,
                  nm_arq_nota: res.data[0].name,
                  hash_arq_nota: res.data[0].hash + res.data[0].ext,
                };

                await api
                  .put(`/documentos/${documentId}`, documentData)
                  .then(async (res) => {
                    const newDocument = res.data[0];
                    const historyData = {
                      documento: res.data[0].id,
                      users_permissions_user: user?.id,
                      status_documento: 12,
                      dt_vencimento: res.data[0].dt_vencimento,
                      id_arq_boleto: res.data[0].id_arq_boleto,
                      nm_arq_boleto: res.data[0].nm_arq_boleto,
                      hash_arq_boleto: res.data[0].hash_arq_boleto,
                      id_arq_nota: res.data[0].id_arq_nota,
                      nm_arq_nota: res.data[0].nm_arq_nota,
                      hash_arq_nota: res.data[0].hash_arq_nota,
                    };

                    await api
                      .post("/hist-validacao-docs", historyData)
                      .then((res) => {
                        const arrayDoc = documents.filter(
                          (doc) => doc.id !== documentId,
                        );

                        setDocuments(
                          [
                            ...arrayDoc,
                            {
                              ...newDocument,
                              hist_validacao_docs: [
                                ...newDocument.hist_validacao_docs,
                                res.data,
                              ],
                            },
                          ].sort(sortMesCompetencia),
                        );

                        Swal.fire({
                          position: "center",
                          icon: "success",
                          title: "Arquivos de utilização enviados com sucesso",
                          showConfirmButton: false,
                          timer: 3000,
                        }).then(() => {
                          onClose();
                        });
                      })
                      .catch((error) => {
                        console.log("erro: ", error);
                        Swal.fire({
                          icon: "warning",
                          title:
                            "Erro ao cadastrar o histórico do documento! Entre em contato com o administrador do sistema",
                          showConfirmButton: true,
                          confirmButtonText: `Ok`,
                        });
                      });
                  })
                  .catch((error) => {
                    console.log("erro: ", error);
                    Swal.fire({
                      icon: "warning",
                      title:
                        "Erro ao cadastrar o documento! Entre em contato com o administrador do sistema",
                      showConfirmButton: true,
                      confirmButtonText: `Ok`,
                    });
                  });
                reset(defaultValues);
                setClick(null);
                setdocumentId(null);
                setFile(null);
                setFile2(null);
              })
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao enviar utilização sintética! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          })
          .catch((error) => {
            console.log("erro: ", error);
            Swal.fire({
              icon: "warning",
              title:
                "Erro ao enviar a utilização analítica! Entre em contato com o administrador do sistema",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          });
        setIsSending(false);
      }

      setIsSending(false);
    });
  };

  useEffect(() => {
    async function getEntidades() {
      try {
        const response = await api.get(
          `/usuarios-contratoes?users_permissions_user=${user?.id}`,
        );
        if (response.data.length > 0) {
          setContratos(
            response.data[0].contratoes.filter(
              (contrato: any) => contrato.fl_sinistralidade,
            ),
          );
        }
        if (selectedContract && linkExterno) {
          setStatusContract("ativo");
          setDocuments([]);
          setNameContrato(
            response.data[0].contratoes
              .filter((ent: any) => ent.fl_sinistralidade)
              .filter(
                (cont: any) => parseInt(cont.id) === parseInt(selectedContract),
              )[0].desc_contrato,
          );
          getDocuments(moment().year(), selectedContract);
          setLinkExterno(false);
        }

        setPageLoadingEntidades(false);
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar as Pessoas Jurídicas",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    getEntidades();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // useEffect(() => {
  //   if (selectedContract) {
  //     setSteps([
  //       ...steps,
  //       {
  //         selector: '[id="containerDocument"]',
  //         content:
  //           "Aqui ficam todas as informações financeiras do seu contrato, sendo possível verificar a competência, o status, se foi ou não enviado, a última modificação, o valor, a fatura, a data de vencimento e todo o histórico.",
  //       },
  //       {
  //         selector: '[id="send-edit-button"]',
  //         content:
  //           "Aqui você pode enviar um arquivo, editar e acompanhar o andamento dele no mês vigente, caso ainda não tenha sido validado.",
  //       },
  //       {
  //         selector: '[id="ticket"]',
  //         content: "Aqui você pode olhar seu boleto e nota.",
  //       },
  //       {
  //         selector: '[id="reloadContractInfo"]',
  //         content:
  //           "Para verificar as informações mais atuais desse contrato, basta recarregar as informações dele ao clicar aqui.",
  //       },
  //     ]);
  //   } else {
  //     setSteps(movimentacaoSteps);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedContract]);

  const handleChangeSelectedContract = (selectedOption: any) => {
    getDocuments(moment().year(), selectedOption.value);
    setSelectedContract(selectedOption.value);
  };

  if (pageLoadingEntidades) {
    return (
      <Box
        as="section"
        display="flex"
        w="100%"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress isIndeterminate color="blue.200" />
      </Box>
    );
  }

  return (
    contratos && (
      <>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          overflow="hidden"
          h={notebook ? "calc(100vh + 40px)" : "unset"}
          margin="30px"
          gridRowGap="15px"
          position="relative"
        >
          <>
            {contratos &&
              contratos.filter((doc: any) => !doc.fl_ativo).length > 0 && (
                <Box
                  display="flex"
                  flexDirection={mobile ? "column" : "row"}
                  gridGap="15px"
                  width="100%"
                  height="max-content"
                  maxWidth="500px"
                  padding="12px"
                  backgroundColor="#fff"
                  boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
                >
                  <FormControl>
                    <FormLabel htmlFor="ano">Status dos contratos:</FormLabel>
                    <Select
                      id="statusContrato"
                      name="statusContrato"
                      type="text"
                      onChange={(e: any) => {
                        setStatusContract(e.target.value);
                        setDocuments([]);
                        setSelect(false);
                      }}
                      value={statusContract}
                    >
                      <option key="1" value="ativo">
                        Ativos
                      </option>
                      <option key="2" value="inativo">
                        Inativos
                      </option>
                    </Select>
                  </FormControl>
                </Box>
              )}
            <Flex>
              <Box
                display="flex"
                flexDirection={mobile ? "column" : "row"}
                gridGap="15px"
                width="100%"
                height="max-content"
                maxWidth="500px"
                padding="12px"
                backgroundColor="#fff"
                boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
                id="containerSelectContract"
              >
                <FormControl>
                  <FormLabel htmlFor="contratos">
                    Contratos{" "}
                    {statusContract === "ativo" ? "ativos" : "inativos"}:
                  </FormLabel>
                  <ReactSelect
                    className="basic-single"
                    classNamePrefix="select"
                    closeMenuOnSelect={true}
                    isSearchable={true}
                    placeholder="Selecione um contrato"
                    noOptionsMessage={() => "-"}
                    onChange={handleChangeSelectedContract}
                    defaultValue={
                      selectedContract && {
                        value: selectedContract,
                        label: nameContrato,
                      }
                    }
                    options={contratos
                      .filter((doc: any) =>
                        statusContract === "ativo"
                          ? doc.fl_ativo
                          : !doc.fl_ativo,
                      )
                      .map((contrato: any) => ({
                        value: contrato.id,
                        label: contrato.desc_contrato,
                      }))}
                    components={animatedComponents}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel htmlFor="ano">Ano:</FormLabel>
                  <Select
                    id="ano"
                    name="ano"
                    type="text"
                    onChange={(e: any) => {
                      getDocuments(e.target.value, null);
                      setYearValue(e.target.value);
                    }}
                    value={yearValue}
                  >
                    {years &&
                      years.map((year: any) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                  </Select>
                </FormControl>
              </Box>
              {/* <Button
                colorScheme="teal"
                variant="link"
                ml="20px"
                onClick={() => setIsOpen(true)}
              >
                <Icon as={MdHelpOutline} mr="5px" />
                Ajuda
              </Button> */}
            </Flex>
            {selectedContract && (
              <Button
                position="absolute"
                right="10px"
                top={
                  contratos &&
                  contratos.filter((doc: any) => !doc.fl_ativo).length > 0
                    ? mobile
                      ? "300px"
                      : "175px"
                    : mobile
                    ? "300px"
                    : "65px"
                }
                margin="0 auto"
                colorScheme="unset"
                variant="solid"
                padding="0"
                color="#555"
                cursor="pointer"
                _hover={{
                  backgroundColor: "#e3e8f0",
                  color: "blue.600",
                }}
                onClick={() => getDocuments(moment().year(), selectedContract)}
                id="reloadContractInfo"
              >
                {pageLoading ? (
                  <CircularProgress
                    isIndeterminate
                    size="22"
                    color="blue.200"
                  />
                ) : (
                  <AiOutlineReload size="25" />
                )}
              </Button>
            )}

            {selectedContract && documents.length > 0 ? (
              <>
                {pageLoading ? (
                  <Box
                    as="section"
                    display="flex"
                    w="100%"
                    height="300px"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <CircularProgress isIndeterminate color="blue.200" />
                  </Box>
                ) : (
                  <>
                    <Box
                      display="flex"
                      marginTop={mobile ? "40px" : 0}
                      flexDirection="column"
                      overflow="auto"
                      width="100%"
                      height="max-content"
                      padding="15px"
                      backgroundColor="#fff"
                      boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
            0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
                    >
                      <Box
                        fontSize="17px"
                        display="grid"
                        gridTemplateColumns="110px 200px 150px 150px 96px 96px 77px"
                        justifyContent="space-between"
                        padding="0 5px"
                        minWidth="960px"
                        alignItems="center"
                      >
                        <Text paddingLeft="5px">Mês</Text>
                        <Text>Status</Text>
                        <Text textAlign="center">Data para envio</Text>
                        <Text textAlign="center">Upload dos arquivos</Text>
                        <Text textAlign="center">Download</Text>
                        <Text textAlign="center">Modificação</Text>
                        <Text textAlign="center">Histórico</Text>
                      </Box>
                      <Accordion allowToggle>
                        {documents &&
                          documents.length > 0 &&
                          documents.map((doc, i) => (
                            <AccordionItem
                              key={i}
                              border="none"
                              margin="5px 0"
                              minWidth="960px"
                              backgroundColor="#eee"
                              borderRadius="12px"
                              _hover={{ backgroundColor: "#e3e8f0" }}
                            >
                              <Box
                                fontSize="16px"
                                display="grid"
                                gridTemplateColumns="110px 200px 150px 150px 96px 96px 77px"
                                minWidth="960px"
                                justifyContent="space-between"
                                padding="5px"
                                alignItems="center"
                              >
                                <Text paddingLeft="5px" fontSize="17px">
                                  {meses[doc.mes_competencia - 1]}
                                </Text>

                                <Alert
                                  padding="5px 5px 5px 0"
                                  backgroundColor="unset"
                                  status={
                                    doc.status_documento === 12 ||
                                    doc.status_documento.id === 12
                                      ? "success"
                                      : "warning"
                                  }
                                >
                                  <AlertIcon />

                                  <Text>
                                    {doc.status_documento === 1 ||
                                    doc.status_documento.id === 1
                                      ? "Não enviado"
                                      : doc.status_documento === 12 ||
                                        doc.status_documento.id === 12
                                      ? "Enviado"
                                      : (doc.status_documento === 13 ||
                                          doc.status_documento.id === 13) &&
                                        "Arquivos excluídos. Aguardando reenvio"}
                                  </Text>
                                </Alert>

                                <Text textAlign="center">
                                  {moment(doc.dt_vencimento).format(
                                    "DD/MM/YYYY",
                                  )}
                                </Text>

                                {(doc.status_documento === 1 ||
                                  doc.status_documento.id === 1 ||
                                  doc.status_documento === 13 ||
                                  doc.status_documento.id === 13 ||
                                  doc.status_documento === 12 ||
                                  doc.status_documento.id === 12) &&
                                statusContract === "ativo" ? (
                                  <Text textAlign="center">
                                    <Button
                                      onClick={
                                        doc.status_documento === 1 ||
                                        doc.status_documento.id === 1 ||
                                        doc.status_documento === 13 ||
                                        doc.status_documento.id === 13
                                          ? () => {
                                              onOpen();
                                              setdocumentId(doc.id);
                                              setClick("enviar");
                                              setObservacao(doc);
                                            }
                                          : doc.status_documento === 12 ||
                                            doc.status_documento.id === 12
                                          ? () => {
                                              onOpen();
                                              setdocumentId(doc.id);
                                              setClick("suporte");
                                              setObservacao(doc);
                                            }
                                          : () => {}
                                      }
                                      margin="0 auto"
                                      colorScheme="unset"
                                      variant="solid"
                                      padding="0"
                                      color="orange.600"
                                      cursor="pointer"
                                      _hover={{
                                        backgroundColor: "#cad8eb",
                                        color: "blue.600",
                                      }}
                                    >
                                      {doc.status_documento === 12 ||
                                      doc.status_documento.id === 12 ? (
                                        <MdEdit size="20px" color="#1f71a0" />
                                      ) : (
                                        <MdFileUpload size="20px" />
                                      )}
                                    </Button>
                                  </Text>
                                ) : (
                                  <Text textAlign="center">-</Text>
                                )}

                                {doc.status_documento === 12 ||
                                doc.status_documento.id === 12 ? (
                                  <Text textAlign="center">
                                    <Button
                                      onClick={
                                        doc.status_documento === 12 ||
                                        doc.status_documento.id === 12
                                          ? () => {
                                              onOpen();
                                              setdocumentId(doc.id);
                                              setClick("download");
                                              setObservacao(doc);
                                            }
                                          : () => {}
                                      }
                                      margin="0 auto"
                                      colorScheme="unset"
                                      variant="solid"
                                      padding="0"
                                      color="green.600"
                                      cursor="pointer"
                                      _hover={{
                                        backgroundColor: "#cad8eb",
                                        color: "blue.600",
                                      }}
                                    >
                                      <MdFileDownload size="20px" />
                                    </Button>
                                  </Text>
                                ) : (
                                  <Text textAlign="center">-</Text>
                                )}

                                {doc.status_documento === 1 ||
                                doc.status_documento.id === 1 ? (
                                  <Text textAlign="center">-</Text>
                                ) : (
                                  <Text textAlign="center">
                                    {moment(doc.updated_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>
                                )}

                                <AccordionButton
                                  margin="0 auto"
                                  justifyContent="center"
                                  width="40px"
                                  height="40px"
                                  padding="0"
                                  borderRadius="8px"
                                  _hover={{
                                    backgroundColor: "#cad8eb",
                                    color: "blue.600",
                                  }}
                                >
                                  <AccordionIcon />
                                </AccordionButton>
                              </Box>
                              <AccordionPanel
                                padding="20px"
                                borderTop="1px solid white"
                              >
                                <Box display="flex">
                                  {doc?.hist_validacao_docs?.length > 0 ? (
                                    <>
                                      <Box
                                        width="100%"
                                        borderRadius="12px"
                                        margin="2px 0"
                                        padding="5px"
                                        height="max-content"
                                      >
                                        <Text
                                          width="max-content"
                                          margin="5px"
                                          fontSize="18px"
                                          fontWeight="500"
                                        >
                                          Histórico
                                        </Text>
                                        <Box
                                          fontSize="16px"
                                          display="grid"
                                          gridTemplateColumns="27% 26% 11% 11% 14% 11%"
                                          width="100%"
                                          padding="5px"
                                          alignItems="center"
                                        >
                                          <Text>Status</Text>
                                          <Text textAlign="center">
                                            Usuário
                                          </Text>
                                          <Text textAlign="center">
                                            Modificação
                                          </Text>
                                          <Text textAlign="center">Hora</Text>

                                          <Text textAlign="center">
                                            Arquivos
                                          </Text>

                                          <Text textAlign="center">
                                            Observação
                                          </Text>
                                        </Box>
                                        {doc.hist_validacao_docs
                                          .sort(sortDESC)
                                          .map((hist: any) => (
                                            <Box
                                              key={hist.id}
                                              borderTop="1px solid white"
                                              fontSize="16px"
                                              display="grid"
                                              gridTemplateColumns="27% 26% 11% 11% 14% 11%"
                                              width="100%"
                                              padding="5px"
                                              alignItems="center"
                                              // _hover={{
                                              //   backgroundColor: "#d5e1ea",
                                              // }}
                                            >
                                              <Alert
                                                padding="5px"
                                                backgroundColor="unset"
                                                status={
                                                  hist.status_documento.id ===
                                                    12 ||
                                                  hist.status_documento === 12
                                                    ? "success"
                                                    : "warning"
                                                }
                                              >
                                                <AlertIcon />
                                                {hist.status_documento.id ===
                                                  12 ||
                                                hist.status_documento === 12
                                                  ? "Enviado"
                                                  : hist.status_documento.id ===
                                                      13 ||
                                                    hist.status_documento === 13
                                                  ? "Arquivos excluídos. Aguardando reenvio"
                                                  : "Não enviado"}
                                              </Alert>
                                              <Text
                                                textAlign="center"
                                                fontSize="15px"
                                              >
                                                {
                                                  hist.users_permissions_user
                                                    .nome
                                                }
                                              </Text>
                                              <Text textAlign="center">
                                                {moment(
                                                  hist.published_at,
                                                ).format("DD/MM/YYYY")}
                                              </Text>
                                              <Text textAlign="center">
                                                {moment(
                                                  hist.published_at,
                                                ).format("HH:mm")}
                                              </Text>

                                              {hist.id_arq_nota ||
                                              hist.id_arq_boleto ? (
                                                <Text textAlign="center">
                                                  <Button
                                                    onClick={() => {
                                                      onOpen();
                                                      setClick("downloadHist");
                                                      setObservacao(hist);
                                                    }}
                                                    colorScheme="unset"
                                                    variant="solid"
                                                    padding="0"
                                                    color="#555"
                                                    _hover={{
                                                      backgroundColor:
                                                        "#cad8eb",
                                                      color: "blue.600",
                                                    }}
                                                  >
                                                    <MdFileDownload size="22px" />
                                                  </Button>
                                                </Text>
                                              ) : (
                                                <Text textAlign="center">
                                                  -
                                                </Text>
                                              )}

                                              {hist.observacao ? (
                                                <Text textAlign="center">
                                                  <Button
                                                    onClick={() => {
                                                      onOpen();
                                                      setClick("observacao");
                                                      setObservacao(hist);
                                                    }}
                                                    colorScheme="unset"
                                                    variant="solid"
                                                    padding="0"
                                                    color="#555"
                                                    _hover={{
                                                      backgroundColor:
                                                        "#cad8eb",
                                                      color: "blue.600",
                                                    }}
                                                  >
                                                    <BiCommentDetail size="22px" />
                                                  </Button>
                                                </Text>
                                              ) : (
                                                <Text textAlign="center">
                                                  -
                                                </Text>
                                              )}
                                            </Box>
                                          ))}
                                      </Box>
                                    </>
                                  ) : (
                                    <Text
                                      padding="5px 5px 0"
                                      fontSize="18px"
                                      fontWeight="bold"
                                    >
                                      Sem Histórico
                                    </Text>
                                  )}
                                </Box>
                              </AccordionPanel>
                            </AccordionItem>
                          ))}
                      </Accordion>
                    </Box>

                    <Modal
                      scrollBehavior="inside"
                      isCentered
                      onClose={() => {
                        reset();
                        setClick(null);
                        setObservacao(null);
                        onClose();
                      }}
                      isOpen={isOpen}
                      motionPreset="slideInBottom"
                    >
                      <ModalOverlay />
                      <ModalContent>
                        {click && click === "enviar" ? (
                          <>
                            <ModalHeader>
                              Enviar arquivos
                              <br />
                              <Box
                                fontSize="14px"
                                color="#E53E3E"
                                fontWeight="100"
                                marginTop="10px"
                              >
                                (*) indica os campos obrigatórios
                              </Box>
                            </ModalHeader>

                            <ModalCloseButton />
                            <ModalBody>
                              <form
                                onSubmit={handleSubmit(sendFile)}
                                onReset={(event) => {
                                  event.preventDefault();
                                  reset(defaultValues);
                                }}
                              >
                                <Grid gap={6}>
                                  <Box fontWeight="500">
                                    Competência: {observacao.mes_competencia}/
                                    {observacao.ano_competencia}
                                  </Box>
                                  <FormControl
                                    isRequired
                                    isInvalid={
                                      file
                                        ? file?.name.split(".")[1] === "xlsx" ||
                                          file?.name.split(".")[1] === "xls" ||
                                          file?.name.split(".")[1] === "csv"
                                          ? false
                                          : true
                                        : false
                                    }
                                  >
                                    <FormLabel htmlFor="sinistralidade_aberta">
                                      Arquivo Analítico
                                    </FormLabel>
                                    <Input
                                      color="blue.600"
                                      padding="5px"
                                      id="sinistralidade_aberta"
                                      name="sinistralidade_aberta"
                                      type="file"
                                      onChange={(e: any) =>
                                        setFile(e.target.files[0])
                                      }
                                    />
                                    <FormErrorMessage fontWeight="500">
                                      * Tipos de arquivos permitidos (XLSX, XLS
                                      e CSV)
                                    </FormErrorMessage>
                                  </FormControl>

                                  <FormControl
                                    isRequired
                                    isInvalid={
                                      file2
                                        ? file2?.name.split(".")[1] === "png" ||
                                          file2?.name.split(".")[1] === "jpg" ||
                                          file2?.name.split(".")[1] ===
                                            "jpeg" ||
                                          file2?.name.split(".")[1] === "zip" ||
                                          file2?.name.split(".")[1] === "pdf" ||
                                          file2?.name.split(".")[1] === "img" ||
                                          file2?.name.split(".")[1] ===
                                            "docx" ||
                                          file2?.name.split(".")[1] === "doc" ||
                                          file2?.name.split(".")[1] ===
                                            "xlsx" ||
                                          file2?.name.split(".")[1] === "xls" ||
                                          file2?.name.split(".")[1] === "csv" ||
                                          file2?.name.split(".")[1] === "rar"
                                          ? false
                                          : true
                                        : false
                                    }
                                  >
                                    <FormLabel htmlFor="sinistralidade_fechada">
                                      Arquivo Sintético
                                    </FormLabel>
                                    <Input
                                      color="blue.600"
                                      padding="5px"
                                      id="sinistralidade_fechada"
                                      name="sinistralidade_fechada"
                                      type="file"
                                      onChange={(e: any) =>
                                        setFile2(e.target.files[0])
                                      }
                                    />
                                    <FormErrorMessage fontWeight="500">
                                      * Tipos de arquivos permitidos (PDF, JPEG,
                                      PNG, IMG, DOCX, DOC, XLSX, XLS, CSV, RAR,
                                      ZIP)
                                    </FormErrorMessage>
                                  </FormControl>

                                  <Button
                                    colorScheme="blue"
                                    isLoading={isSending}
                                    type="submit"
                                    disabled={
                                      (file?.name.split(".")[1] === "png" ||
                                      file?.name.split(".")[1] === "jpg" ||
                                      file?.name.split(".")[1] === "jpeg" ||
                                      file?.name.split(".")[1] === "zip" ||
                                      file?.name.split(".")[1] === "pdf" ||
                                      file?.name.split(".")[1] === "img" ||
                                      file?.name.split(".")[1] === "docx" ||
                                      file?.name.split(".")[1] === "doc" ||
                                      file?.name.split(".")[1] === "xlsx" ||
                                      file?.name.split(".")[1] === "xls" ||
                                      file?.name.split(".")[1] === "csv" ||
                                      file?.name.split(".")[1] === "rar"
                                        ? false
                                        : true) ||
                                      (file2?.name.split(".")[1] === "png" ||
                                      file2?.name.split(".")[1] === "jpg" ||
                                      file2?.name.split(".")[1] === "jpeg" ||
                                      file2?.name.split(".")[1] === "zip" ||
                                      file2?.name.split(".")[1] === "pdf" ||
                                      file2?.name.split(".")[1] === "img" ||
                                      file2?.name.split(".")[1] === "docx" ||
                                      file2?.name.split(".")[1] === "doc" ||
                                      file2?.name.split(".")[1] === "xlsx" ||
                                      file2?.name.split(".")[1] === "xls" ||
                                      file2?.name.split(".")[1] === "csv" ||
                                      file2?.name.split(".")[1] === "rar"
                                        ? false
                                        : true)
                                    }
                                  >
                                    Enviar
                                  </Button>
                                </Grid>
                              </form>
                            </ModalBody>
                            <ModalFooter></ModalFooter>
                          </>
                        ) : click && click === "observacao" && observacao ? (
                          <>
                            <ModalHeader>
                              <Alert
                                padding="5px"
                                backgroundColor="unset"
                                status="warning"
                              >
                                <AlertIcon />
                                Arquivos excluídos. <br />
                                Aguardando reenvio
                              </Alert>
                              <Divider />
                              <Box
                                fontSize="14px"
                                fontWeight="500"
                                display="flex"
                                gridColumnGap="20px"
                                justifyContent="space-between"
                              >
                                <Text>
                                  Usuário:{" "}
                                  {observacao.users_permissions_user.nome}
                                </Text>
                                <Text>
                                  Data:{" "}
                                  {moment(observacao.updated_at).format(
                                    "DD/MM/YYYY",
                                  )}
                                </Text>
                                <Text>
                                  Hora:{" "}
                                  {moment(observacao.updated_at).format(
                                    "HH:mm",
                                  )}
                                </Text>
                              </Box>
                              <Box
                                fontSize="14px"
                                fontWeight="500"
                                display="flex"
                                gridColumnGap="20px"
                              >
                                <Text>Fatura: {observacao.nome_arquivo}</Text>
                              </Box>
                              <Divider />
                            </ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                              <Text
                                backgroundColor="#f2f2f2"
                                textAlign="center"
                                fontSize="18px"
                                padding="20px 10px"
                                marginBottom="15px"
                              >
                                {observacao.observacao}
                              </Text>
                            </ModalBody>
                          </>
                        ) : click && click === "download" && observacao ? (
                          <>
                            <ModalHeader>
                              <Alert
                                padding="5px"
                                backgroundColor="unset"
                                status={
                                  observacao.status_documento.id === 12 ||
                                  observacao.status_documento === 12
                                    ? "success"
                                    : "warning"
                                }
                              >
                                <AlertIcon />
                                Arquivos
                              </Alert>
                              <Divider />
                              <Box
                                fontSize="14px"
                                fontWeight="500"
                                display="flex"
                                gridColumnGap="10px"
                                justifyContent="space-between"
                              >
                                <Text>
                                  Usuário:{" "}
                                  {
                                    observacao?.hist_validacao_docs[0]
                                      ?.users_permissions_user?.nome
                                  }
                                </Text>
                                <Text>
                                  Data:{" "}
                                  {moment(observacao.updated_at).format(
                                    "DD/MM/YYYY",
                                  )}
                                </Text>
                                <Text>
                                  Hora:{" "}
                                  {moment(observacao.updated_at).format(
                                    "HH:mm",
                                  )}
                                </Text>
                              </Box>
                              <Divider />
                            </ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                              <Grid gap={6}>
                                <Box fontWeight="500">
                                  Competência: {observacao.mes_competencia}/
                                  {observacao.ano_competencia}
                                </Box>
                                <FormControl>
                                  <FormLabel htmlFor="sinistralidade_01">
                                    Arquivo Analítico
                                  </FormLabel>
                                  <Input
                                    readOnly
                                    padding="10px"
                                    id="sinistralidade_01"
                                    name="sinistralidade_01"
                                    value={observacao.nm_arq_boleto}
                                  />
                                  <Button
                                    onClick={() =>
                                      download(observacao.hash_arq_boleto)
                                    }
                                    background="#cad8eb"
                                    width="100%"
                                    margin="5px auto 0"
                                    display="flex"
                                    fontSize="18px"
                                    colorScheme="unset"
                                    variant="solid"
                                    padding="0 10px"
                                    color="#555"
                                    cursor="pointer"
                                    _hover={{
                                      backgroundColor: "#acc2e0",
                                      color: "blue.600",
                                    }}
                                  >
                                    <MdFileDownload size="25px" />
                                    <Text paddingBottom="2px" marginLeft="5px">
                                      Baixar arquivo Analítico
                                    </Text>
                                  </Button>
                                </FormControl>

                                <FormControl>
                                  <FormLabel htmlFor="sinistralidade_02">
                                    Arquivo Sintético
                                  </FormLabel>
                                  <Input
                                    readOnly
                                    padding="10px"
                                    id="sinistralidade_02"
                                    name="sinistralidade_02"
                                    value={observacao.nm_arq_nota}
                                  />
                                  <Button
                                    onClick={() =>
                                      download(observacao.hash_arq_nota)
                                    }
                                    background="#cad8eb"
                                    width="100%"
                                    margin="5px auto 0"
                                    display="flex"
                                    fontSize="18px"
                                    colorScheme="unset"
                                    variant="solid"
                                    padding="0 10px"
                                    color="#555"
                                    cursor="pointer"
                                    _hover={{
                                      backgroundColor: "#acc2e0",
                                      color: "blue.600",
                                    }}
                                  >
                                    <MdFileDownload size="25px" />
                                    <Text paddingBottom="2px" marginLeft="5px">
                                      Baixar Arquivo Sintético
                                    </Text>
                                  </Button>
                                </FormControl>
                              </Grid>
                            </ModalBody>
                            <ModalFooter></ModalFooter>
                          </>
                        ) : click && click === "downloadHist" && observacao ? (
                          <>
                            <ModalHeader>
                              <Alert
                                padding="5px"
                                backgroundColor="unset"
                                status={
                                  observacao.status_documento.id === 12 ||
                                  observacao.status_documento === 12
                                    ? "success"
                                    : "warning"
                                }
                              >
                                <AlertIcon />
                                Arquivos
                              </Alert>
                              <Divider />
                              <Box
                                fontSize="14px"
                                fontWeight="500"
                                display="flex"
                                gridColumnGap="10px"
                                justifyContent="space-between"
                              >
                                <Text>
                                  Usuário:{" "}
                                  {observacao?.users_permissions_user?.nome}
                                </Text>
                                <Text>
                                  Data:{" "}
                                  {moment(observacao.updated_at).format(
                                    "DD/MM/YYYY",
                                  )}
                                </Text>
                                <Text>
                                  Hora:{" "}
                                  {moment(observacao.updated_at).format(
                                    "HH:mm",
                                  )}
                                </Text>
                              </Box>
                              <Divider />
                            </ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                              <Grid gap={6}>
                                <FormControl>
                                  <FormLabel htmlFor="sinistralidade_01">
                                    Arquivo Analítico
                                  </FormLabel>
                                  {console.log(observacao)}
                                  <Input
                                    readOnly
                                    padding="10px"
                                    id="sinistralidade_01"
                                    name="sinistralidade_01"
                                    value={observacao.nm_arq_boleto}
                                  />
                                  <Button
                                    onClick={() =>
                                      download(observacao.hash_arq_boleto)
                                    }
                                    background="#cad8eb"
                                    width="100%"
                                    margin="5px auto 0"
                                    display="flex"
                                    fontSize="18px"
                                    colorScheme="unset"
                                    variant="solid"
                                    padding="0 10px"
                                    color="#555"
                                    cursor="pointer"
                                    _hover={{
                                      backgroundColor: "#acc2e0",
                                      color: "blue.600",
                                    }}
                                  >
                                    <MdFileDownload size="25px" />
                                    <Text paddingBottom="2px" marginLeft="5px">
                                      Baixar Arquivo Analítico
                                    </Text>
                                  </Button>
                                </FormControl>

                                <FormControl>
                                  <FormLabel htmlFor="sinistralidade_02">
                                    Arquivo Sintético
                                  </FormLabel>
                                  <Input
                                    readOnly
                                    padding="10px"
                                    id="sinistralidade_02"
                                    name="sinistralidade_02"
                                    value={observacao.nm_arq_nota}
                                  />
                                  <Button
                                    onClick={() =>
                                      download(observacao.hash_arq_nota)
                                    }
                                    background="#cad8eb"
                                    width="100%"
                                    margin="5px auto 0"
                                    display="flex"
                                    fontSize="18px"
                                    colorScheme="unset"
                                    variant="solid"
                                    padding="0 10px"
                                    color="#555"
                                    cursor="pointer"
                                    _hover={{
                                      backgroundColor: "#acc2e0",
                                      color: "blue.600",
                                    }}
                                  >
                                    <MdFileDownload size="25px" />
                                    <Text paddingBottom="2px" marginLeft="5px">
                                      Baixar Arquivo Sintético
                                    </Text>
                                  </Button>
                                </FormControl>
                              </Grid>
                            </ModalBody>
                            <ModalFooter></ModalFooter>
                          </>
                        ) : (
                          click &&
                          click === "suporte" &&
                          observacao && (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status={"success"}
                                >
                                  <AlertIcon />
                                  Enviado
                                </Alert>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Text
                                  backgroundColor="#f2f2f2"
                                  textAlign="center"
                                  fontSize="18px"
                                  padding="20px 10px"
                                  marginBottom="15px"
                                >
                                  Olá {user?.nome}, o arquivo enviado já esta em
                                  análise para importação no sistema. Caso
                                  deseje realizar alguma alteração registre um
                                  chamado na opção de suporte.
                                </Text>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  marginBottom="20px"
                                >
                                  <Button colorScheme="blue">
                                    <Link
                                      target="_blank"
                                      to="/portal/suporte"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <MdRecordVoiceOver size="20px" />
                                      Suporte
                                    </Link>
                                  </Button>
                                </Box>
                              </ModalBody>
                            </>
                          )
                        )}
                      </ModalContent>
                    </Modal>
                  </>
                )}
              </>
            ) : (
              selectedContract &&
              select &&
              !pageLoading && (
                <Alert
                  status="info"
                  fontSize="18px"
                  marginTop={mobile ? "40px" : 0}
                  fontWeight="500"
                >
                  {vigenciaContratoAtivo ? (
                    <>
                      <AlertIcon />A primeira competência será disponibilizada
                      em {vigenciaContrato}.
                    </>
                  ) : (
                    <>
                      <AlertIcon />
                      Contrato encerrado antes da primeira competência ser
                      disponibilizada.
                    </>
                  )}
                </Alert>
              )
            )}
          </>
        </Box>
      </>
    )
  );
};

export default UtilizacaoPortal;
